import type { ApiResponse } from "@/types/common";
import { privateRequest } from "../axios";
import { type AxiosResponse } from "axios";

export interface Event {
  id: number;
  name: string;
  eventType: string;
  description: string;
  eventDate: string;
  eventStartTime: string;
  eventEndTime: string;
  capacity: number;
  guidelines: string | null;
  mapUrl: string | null;
  location: string | null;
  isEventAttended: boolean;
}

export interface GetAvailableEventsResponse {
  totalRecord: number;
  results: Event[];
}

interface GetAvailableEventsRequest {
  page?: number;
  size?: number;
  sort?: string[];
  isEventApplied?: boolean;
}

interface ApplyToEventRequest {
  preferredLocation: string;
  eventId: number | string;
}

const ENDPOINTS = {
  GET_AVAILABLE_EVENTS: "/events/available",
  GET_SUBSCRIBED_EVENTS: "/subscription/me",
};

const getAvailableEvents = async (
  params?: GetAvailableEventsRequest,
): Promise<ApiResponse<GetAvailableEventsResponse>> => {
  try {
    const response: AxiosResponse<ApiResponse<GetAvailableEventsResponse>> =
      await privateRequest.get(ENDPOINTS.GET_AVAILABLE_EVENTS, { params });
    return response.data;
  } catch (error: any) {
    throw error.response?.data || error;
  }
};

const getSubscribedEvents = async (): Promise<ApiResponse<GetAvailableEventsResponse>> => {
  try {
    const response: AxiosResponse<ApiResponse<GetAvailableEventsResponse>> =
      await privateRequest.get(ENDPOINTS.GET_SUBSCRIBED_EVENTS);
    return response.data;
  } catch (error: any) {
    throw error.response?.data || error;
  }
};

const applyToEvent = async (
  eventId: number | string,
  data: ApplyToEventRequest,
): Promise<void> => {
  try {
    await privateRequest.post(`/events/${eventId}/participant`, data);
  } catch (error: any) {
    throw error.response?.data || error;
  }
};

const EventsService = {
  getAvailableEvents,
  getSubscribedEvents,
  applyToEvent,
};
export { getAvailableEvents, getSubscribedEvents, applyToEvent };
export default EventsService;